<div
  #wrapperDiv
  class="date-container"
  [class.is-invalid]="invalid"
  [formlyAttributes]="field"
>
  <div class="date-field-group">
    <label for="day">Day</label>
    <input
      #dayControl
      type="number"
      class="form-control date-input"
      placeholder="DD"
      min="1"
      max="31"
      step="1"
      maxlength="2"
      [ngModel]="dateModel.day"
      [attr.data-testid]="props.testId  + '_day'"
      (keyup)="onKeyup($event, monthControl)"
      (keydown)="onKeydown($event, 'day')"
      (blur)="onBlur('day')"
      (ngModelChange)="updateModel($event, 'day')"
    />
  </div>
  <div class="date-field-group">
    <label for="month">Month</label>
    <input
      #monthControl
      type="number"
      class="form-control date-input"
      placeholder="MM"
      min="1"
      max="12"
      step="1"
      maxlength="2"
      [ngModel]="dateModel.month"
      [attr.data-testid]="props.testId + '_month'"
      (keyup)="onKeyup($event, yearControl)"
      (keydown)="onKeydown($event, 'month')"
      (blur)="onBlur('month')"
      (ngModelChange)="updateModel($event, 'month')"
    />
  </div>
  <div class="date-field-group">
    <label for="year">Year</label>
    <input
      #yearControl
      type="number"
      class="form-control date-input"
      placeholder="YYYY"
      min="1900"
      max="2100"
      step="1"
      maxlength="4"
      [ngModel]="dateModel.year"
      [attr.data-testid]="props.testId + '_year'"
      (blur)="onBlur('year')"
      (keydown)="onKeydown($event, 'year')"
      (ngModelChange)="updateModel($event, 'year')"
    />
  </div>
</div>
